import { ShopSubscriptionType } from 'types/shopSubscription'
import { Action, Dispatch } from 'redux'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { auth } from 'firebase/index'
import axios from 'axios'
import { RETRIEVE_INVOICES_ENDPOINT } from 'constants/urls'
import { Stripe } from 'stripe'
import { retrieveInvoicesAction } from 'reducks/shopSubscription/actions'

const retrieveInvoices = (shopSubscriptions: ShopSubscriptionType[]) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())

    // トークンを取得する
    const token = await auth.currentUser?.getIdToken()

    if (typeof !token === 'undefined') {
      dispatch(hideLoadingAction())
      console.error('認証トークンの取得に失敗しました。')
      return
    }

    const promises = []
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    }

    for (let i = 0; i < shopSubscriptions.length; i = (i + 1) | 0) {
      const shopSubscription = shopSubscriptions[i]
      if (!shopSubscription.stripe_subscription_id || shopSubscription.stripe_subscription_id === '') continue
      promises.push(
        axios.post(
          RETRIEVE_INVOICES_ENDPOINT,
          {
            stripe_subscription_id: shopSubscription.stripe_subscription_id,
          },
          {
            headers,
          }
        )
      )
    }

    const result = await Promise.all(promises).catch((error) => {
      console.error(error)
      dispatch(hideLoadingAction())
      return []
    })

    const invoices: Stripe.Invoice[] = []
    for (let i = 0; i < result.length; i = (i + 1) | 0) {
      const res = result[i]
      if (!res || !res.data || !res.data.invoices) continue
      invoices.push(...res.data.invoices.data)
    }

    invoices.sort((a, b) => (a.period_start > b.period_start ? -1 : 1))
    dispatch(hideLoadingAction())
    dispatch(retrieveInvoicesAction(invoices))
  }
}

export default retrieveInvoices
